export const google_client_id = '560056573397-etdfnfijr8kcdr5g6c4coj1ialma4un1.apps.googleusercontent.com';
export const fb_app_id = "";
export const appleLoginCredential = {
  appleId: '',
  serviceId: '',
  privateKey: '',
  redirectURI:``
}
